import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { TbRefresh } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import {
  addClientData,
  removeClientData
} from "../../../../data/redux/slice/clientOnboardDataSlice";
import {
  clearClientBalanceSlice,
  clearDashboardFilter,
  clearPayoutClientBalanceSlice,
  clearupdatePayoutClientBalanceSlice
} from "../../../../data/redux/slice/countsSlice";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import {
  modalNavigation,
  resellerModalNavigation
} from "../../../../data/redux/slice/modalNavigationSlice";
import {
  addResellerDataAction,
  removeResellerData
} from "../../../../data/redux/slice/resellerDataSlice";
import {
  fetchAllRoleCounts,
  fetchClientBalanceWithIdFromSS,
  fetchClientPayoutBalance,
  fetchClientSecretId,
  fetchClientVoucherBalanceWithIdFromSS,
  fetchClientVoucherBalance,
  fetchPayoutClientBalanceWithIdFromSS,
  fetchTransactionList,
  getAllDashboardTransactionCount,
  getAllDashboardVolumeCount,
  getAllSettlementCount,
  updateMainTransactions,
  fetchCashfreeBalanceOfClient
} from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import {
  AddClientIcon,
  AddPrefundSvg,
  AddResellerIcon,
  DeactivateIcon,
  SendMoneySvg,
  SettlementIcon,
  TransactionIcon,
  UserApprovalIcon
} from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorBlack,
  colorDarkBlue,
  colorWhite,
  primaryColor
} from "../../../../utility/constants/colorManager";
import {
  SS_INDUSTRY_TYPE,
  SS_INTERNAL,
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  APPROVAL_ACL,
  CLIENT,
  CLIENTS_ADD_ACL,
  DASHBOARD_APPROVAL_ACL,
  DEACTIVATE_APPROVAL_ACL,
  RECENT_TRANSACTION_ACL,
  RESELLER,
  RESELLER_ADD_ACL,
  SALES,
  RNC,
  SETTLEMENT_DOWNLOAD_ACL,
  STATUS_CODE_200,
  TRANSACTION_ACL,
  TRANSACTION_COUNT_ACL,
  TRANSACTION_DOWNLOAD_REPORT_ACL,
  TRANSACTION_PAYIN_ACL,
  TRANSACTION_SETTLEMENT_ACL,
  TRANSACTION_VAN_ACL,
  TRANSACTION_VOLUME_ACL,
  USER_COUNT_ACL,
  USER_COUNT_ACL_NEW,
  TRANSACTION_PAYOUT_ACL
} from "../../../../utility/constants/valueConstants";
import {
  RecentTransactionHeaders,
  TransactionHeaderDashboard,
  TransactionHeaders
} from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import ApprovalIndex from "../../../components/ui_comps/approval_comps";
import { checkAnyOneObjHasAllValue } from "../../../components/ui_comps/ComissionContainer";
import MainComponent from "../../../components/ui_comps/MainComponent";
import ClientOnboardIndex from "../clients/client_onboard";
import ResellerOnboardIndex from "../reseller/reseller_onboard";
import DownloadSettlementModal from "../settlement/DownloadSettlement";
import DownloadReportModal from "../transaction/DownloadReportModal";
import AddPrefundModal from "./AddPrefundModal";
import DeactivateModalIndex from "./DeactivateModalIndex";
import FilterModal from "./FilterModal";
import OverviewContainer, {
  SettlementContainer,
  TransactionVolume
} from "./OverviewContainer";
import SendMoneyModal from "./SendMoneyModal";
import AddFundsModal from "./AddFundsModal";
import { useSnackbar } from "notistack";
import {
  fetchResellerDropDownList,
  fetchResellerServiceProviderDropDownList,
  fetchServiceProviderDropDownList
} from "../../../../services/fetchDropdownListData";

const IconContainer = ({ title, icon, onClick }) => {
  return (
    <div style={styles.iconContainer} onClick={onClick}>
      <div style={styles.iconContainer1}>{icon}</div>
      <p style={styles.iconTextStyle}>{title}</p>
    </div>
  );
};

function DashboardIndex() {
  const [openAddClientModal, setOpenAddClientModal] = useState(false);
  const [openAddResellerModal, setOpenAddResellerModal] = useState(false);
  const [onClickApproval, setOnCLickedApproval] = useState(false);
  const [onClickDeactivate, setOnClickDeactivate] = useState(false);
  const [onClickAddPrefund, setOnClickAddPrefund] = useState(false);
  const [onClickSendMoney, setOnClickSendMoney] = useState(false);
  const [onClickAddFunds, setOnClickAddFunds] = useState(false);
  const currentModalStep = useSelector((state) => state.modalNavSlice);
  const [reportModal, setReportModal] = useState(false);
  const [settlementModal, setSettlementModal] = useState(false);
  const [clientDetails, setClientDetials] = useState([]);
  const [clientEskayDetails, setClientEskayDetails] = useState([]);
  const [industryType, setIndustryType] = useState("");
  const internal = secureStorage.getItem(SS_INTERNAL);
  const [cfPayout, setCfPayout] = useState(false);

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const transactionVolumeCount = useSelector(
    (state) => state.dashboardCountSlice.mainTransactionVolume
  );
  const transactionVolumeData = useSelector(
    (state) => state.dashboardCountSlice.transactionVolume
  );
  const transactionCountData = useSelector(
    (state) => state.dashboardCountSlice.transactionCounts
  );
  const lastUpdatedTime = useSelector(
    (state) => state.dashboardCountSlice.lastUpdatedTime
  );
  const settlementCount = useSelector(
    (state) => state.dashboardCountSlice.settlementCount
  );
  const roleCounts = useSelector(
    (state) => state.dashboardCountSlice.roleCounts
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  const transaction = useSelector(
    (state) => state.listingSlice.transactionList
  );
  const Clientid = secureStorage.getItem(SS_USER_HASH_ID);
  const [role, setRole] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const isFilterApplied = useSelector(
    (state) => state.dashboardCountSlice.clearFilters
  );

  const getUserDetails = async () => {
    const role = await secureStorage.getItem(SS_ROLE);
    setRole(role?.toUpperCase());
  };
  const getClientProgram = () => {
    let payout = clientSecret.filter(
      (obj) =>
        obj?.serviceType?.toUpperCase() === "PAYOUT" &&
        (obj.serviceProviderName?.toUpperCase() === "EQUITAS" ||
          obj.serviceProviderName?.toUpperCase() === "ZYRO" ||
          obj.serviceProviderName?.toUpperCase() === "AXIS" ||
          obj.serviceProviderName?.toUpperCase() === "IDFC")
    );

    if (payout.length > 0) {
      setClientDetials(payout);
    }

    let cfPayout = clientSecret.filter(
      (obj) =>
        obj?.serviceType?.toUpperCase() === "PAYOUT" &&
        obj.serviceProviderName?.toUpperCase() === "CASHFREE"
    );
    if (cfPayout.length > 0) {
      setCfPayout(true);
    }

    let payout1 = clientSecret.filter(
      (obj) =>
        obj?.serviceType?.toUpperCase() === "PAYOUT" &&
        obj.serviceProviderName?.toUpperCase() === "ESKAY"
    );
    if (payout1.length > 0) {
      setClientEskayDetails(payout1);
    }
  };

  useEffect(() => {
    getUserDetails();
    dispatch(fetchClientBalanceWithIdFromSS({ id: "", userRefId: "" }));
    dispatch(
      fetchClientVoucherBalance({
        clientId: "",
        resellerId: "",
        serviceProviderName: ""
      })
    );
    dispatch(fetchPayoutClientBalanceWithIdFromSS({ id: "", userRefId: "" }));
    dispatch(
      fetchTransactionList({
        page: 0,
        size: 10
      })
    );
  }, []);

  const checkIfDashboardAclsAreEmpty = () => {
    if (
      !aclData.includes(TRANSACTION_COUNT_ACL) &&
      !aclData.includes(TRANSACTION_SETTLEMENT_ACL) &&
      !aclData.includes(TRANSACTION_VOLUME_ACL) &&
      !aclData.includes(USER_COUNT_ACL) &&
      !aclData.includes(RECENT_TRANSACTION_ACL)
    ) {
      return false;
    } else return true;
  };

  const getIndustryType = async () => {
    setIndustryType();
    const ind = await secureStorage.getItem(SS_INDUSTRY_TYPE);
    setIndustryType(ind?.toUpperCase());
  };

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, [clientSecret, role]);

  useEffect(() => {
    if (role === CLIENT) {
      dispatch(fetchClientSecretId());
      getIndustryType();
    }

    if (internal || role === CLIENT) {
      dispatch(fetchClientBalanceWithIdFromSS({ id: "", userRefId: "" }));
      dispatch(fetchPayoutClientBalanceWithIdFromSS({ id: "", userRefId: "" }));
      dispatch(
        fetchClientVoucherBalanceWithIdFromSS({ id: "", userRefId: "" })
      );

      dispatch(
        fetchTransactionList({
          page: 0,
          size: 10
        })
      );
    }
  }, [role, internal]);

  useEffect(() => {
    const fetchData = async () => {
      if (role?.toUpperCase() === RESELLER) {
        dispatch(fetchResellerServiceProviderDropDownList());
      }
    };

    fetchData();
  }, [role]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "scroll",
        boxSizing: "border-box",
        backgroundColor: bgColor
      }}
    >
      <div style={{ backgroundColor: "white" }}>
        <MainComponent
          filterRequired={false}
          headerTitle="Dashboard"
          onClickFilterCall={(data) => {}}
        />
        <div
          style={{
            backgroundColor: colorWhite,
            padding: "10px 20px"
          }}
        >
          <p style={{ color: "#1E2234", fontSize: "14px", fontWeight: "600" }}>
            QUICK ACTIONS
          </p>

          <div style={styles.iconMainContainer}>
            {(role === "ADMIN" || aclData.includes(RESELLER_ADD_ACL)) && (
              <IconContainer
                title="Add Reseller"
                icon={<AddResellerIcon style={styles.iconStyle} />}
                onClick={() => {
                  setOpenAddResellerModal(true);
                }}
              />
            )}
            {(role === ADMIN || aclData.includes(CLIENTS_ADD_ACL)) && (
              <IconContainer
                title="Add Client"
                icon={<AddClientIcon style={styles.iconStyle} />}
                onClick={() => {
                  // setOpenAddClientModal(true);
                  navigate("/clients/onboard");
                }}
              />
            )}

            {(role === ADMIN ||
              aclData.includes(TRANSACTION_DOWNLOAD_REPORT_ACL)) && (
              <IconContainer
                title="Download Transaction"
                icon={
                  <TransactionIcon
                    style={styles.iconStyle}
                    fill={primaryColor}
                  />
                }
                onClick={() => {
                  setReportModal(true);
                }}
              />
            )}

            {(role === ADMIN || aclData.includes(SETTLEMENT_DOWNLOAD_ACL)) && (
              <IconContainer
                title="Download Settlement"
                icon={
                  <SettlementIcon
                    style={styles.iconStyle}
                    fill={primaryColor}
                  />
                }
                onClick={() => {
                  setSettlementModal(true);
                }}
              />
            )}
            {(role === ADMIN ||
              role === ADMIN_USER ||
              aclData.includes(DASHBOARD_APPROVAL_ACL)) && (
              <IconContainer
                title="Approval"
                icon={<UserApprovalIcon style={styles.iconStyle} />}
                onClick={() => {
                  setOnCLickedApproval(true);
                }}
              />
            )}

            {/* {(role === "ADMIN" || aclData.includes(DASHBOARD_APPROVAL_ACL)) && (
              <IconContainer
                title="Add Prefund"
                icon={<AddPrefundSvg style={styles.iconStyle} />}
                onClick={() => {
                  setOnClickAddPrefund(true);
                }}
              />
            )}
            {(role === "ADMIN" || aclData.includes(DASHBOARD_APPROVAL_ACL)) && (
              <IconContainer
                title="Send Money"
                icon={<SendMoneySvg style={styles.iconStyle} />}
                onClick={() => {
                  setOnClickSendMoney(true);
                }}
              />
            )} */}

            {(role === "ADMIN" ||
              aclData.includes(DEACTIVATE_APPROVAL_ACL)) && (
              <IconContainer
                title="Deactivate Request"
                icon={<DeactivateIcon style={styles.iconStyle} />}
                onClick={() => {
                  setOnClickDeactivate(true);
                }}
              />
            )}
            {role === "CLIENT" &&
              clientDetails.length > 0 &&
              industryType !== "CRYPTO" &&
              clientDetails[0].mechanism !== "van" && (
                <IconContainer
                  title="Add Funds"
                  icon={<SendMoneySvg style={styles.iconStyle} />}
                  onClick={() => {
                    setOnClickAddFunds(true);
                  }}
                />
              )}
            {role === "CLIENT" && clientEskayDetails.length > 0 && (
              <IconContainer
                title="Add Prefund"
                icon={<AddPrefundSvg style={styles.iconStyle} />}
                onClick={() => {
                  setOnClickAddPrefund(true);
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div style={{}}>
        <div
          style={{
            padding: "0px 20px"
          }}
        >
          {checkIfDashboardAclsAreEmpty() && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 0px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "10px 0px"
                }}
              >
                <p
                  style={{
                    fontWeight: "500"
                  }}
                >
                  Overview
                </p>
                <p
                  style={{
                    fontSize: 12,
                    marginLeft: 20
                  }}
                >
                  Last updated :{" "}
                  {lastUpdatedTime
                    ? moment(lastUpdatedTime).format("MMMM Do YYYY, hh:mm A")
                    : "N/A"}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 20
                }}
              >
                <CustomButton
                  title="Refresh"
                  styles={{
                    backgroundColor: colorWhite,
                    border: "1px solid black",
                    width: "auto",
                    padding: "0px 8px"
                  }}
                  textStyles={{
                    color: colorBlack
                  }}
                  showChecked={checkAnyOneObjHasAllValue({})}
                  icon={<TbRefresh size={20} color={primaryColor} />}
                  onClick={() => {
                    dispatch(clearDashboardFilter(false));
                    dispatch(clearClientBalanceSlice());
                    dispatch(clearPayoutClientBalanceSlice());
                    if (cfPayout) {
                      dispatch(fetchCashfreeBalanceOfClient(Clientid));
                    }

                    dispatch(
                      getAllDashboardVolumeCount({
                        clientId: "",
                        resellerId: "",
                        rootReferenceId: "",
                        dateRange: "",
                        serviceProviderName: ""
                      })
                    );
                    dispatch(
                      getAllDashboardTransactionCount({
                        clientId: "",
                        resellerId: "",
                        rootReferenceId: "",
                        dateRange: "",
                        serviceProviderName: ""
                      })
                    );
                    dispatch(
                      getAllSettlementCount({
                        dateRange: "",
                        serviceType: "",
                        userId: "",
                        userRefId: ""
                      })
                    );
                    dispatch(
                      updateMainTransactions({
                        clientId: "",
                        resellerId: "",
                        rootReferenceId: ""
                      })
                    );
                    dispatch(fetchAllRoleCounts());
                    dispatch(
                      fetchTransactionList({
                        page: 0,
                        size: 10
                      })
                    );

                    dispatch(
                      fetchClientBalanceWithIdFromSS({ id: "", userRefId: "" })
                    );
                    dispatch(
                      fetchClientVoucherBalanceWithIdFromSS({
                        id: "",
                        userRefId: ""
                      })
                    );
                    dispatch(
                      fetchClientVoucherBalance({
                        id: "",
                        userRefId: ""
                      })
                    );
                    dispatch(
                      fetchPayoutClientBalanceWithIdFromSS({
                        id: "",
                        userRefId: ""
                      })
                    );
                  }}
                />
                <CustomButton
                  onClick={() => {
                    setOpenFilterModal(true);
                  }}
                  showChecked={isFilterApplied}
                  title="Filter"
                  styles={{
                    backgroundColor: colorWhite,
                    border: "1px solid black",
                    width: "auto",
                    padding: "0px 8px"
                  }}
                  textStyles={{
                    color: colorBlack
                  }}
                />
              </div>
            </div>
          )}

          {openFilterModal && (
            <CustomModal
              open={openFilterModal}
              onClose={() => {
                setOpenFilterModal(false);
              }}
              containerStyle={{
                minWidth: 300,
                maxWidth: 450,
                height: "auto"
              }}
            >
              <FilterModal
                onClose={() => {
                  setOpenFilterModal(false);
                }}
              />
            </CustomModal>
          )}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              flex: 1,
              gap: 20
            }}
          >
            {(role === ADMIN || aclData.includes(TRANSACTION_COUNT_ACL)) && (
              <OverviewContainer
                style={{
                  flex: 4 / 6
                }}
                data={transactionCountData}
                aclData={aclData}
                clientData={clientDetails}
              />
            )}
            {(role === ADMIN ||
              role === ADMIN_USER ||
              (aclData.includes(TRANSACTION_SETTLEMENT_ACL) &&
                (aclData.includes(TRANSACTION_PAYIN_ACL) ||
                  aclData.includes(TRANSACTION_VAN_ACL)))) && (
              <SettlementContainer
                data={settlementCount}
                aclData={aclData}
                unsettledAmount={transactionVolumeCount}
                style={{
                  flex: 2 / 6
                }}
                role={role}
              />
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              flex: 1,
              gap: 20,
              marginTop: 20
            }}
          >
            {role === ADMIN ||
              (aclData.includes(TRANSACTION_VOLUME_ACL) && (
                <TransactionVolume
                  aclData={aclData}
                  data={transactionVolumeData}
                  style={{
                    flex: 4 / 6
                  }}
                />
              ))}
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "white",
          marginTop: "20px",
          padding: "20px 0px"
        }}
      >
        {(role === ADMIN ||
          aclData.includes(USER_COUNT_ACL) ||
          aclData.includes(USER_COUNT_ACL_NEW)) && (
          <div
            style={{
              backgroundColor: "#F9F9FB",
              display: "flex",
              padding: "20px 20px",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap"
            }}
          >
            {role !== RESELLER && role !== CLIENT && (
              <div
                style={{
                  display: "flex",
                  width: "40%",
                  justifyContent: "space-around"
                }}
              >
                <p
                  style={{
                    color: "#6C6B6B",
                    fontSize: "16px",
                    fontWeight: "500"
                  }}
                >
                  Resellers Count
                </p>
                <p
                  style={{
                    color: primaryColor,
                    fontSize: "16px",
                    fontWeight: "500"
                  }}
                >
                  {roleCounts?.reselleCount}
                </p>
              </div>
            )}
            <div
              style={{
                width: "1px",
                height: "60px",
                backgroundColor: "rgba(52, 78, 130, 0.1)"
              }}
            />
            {role !== CLIENT && (
              <div
                style={{
                  display: "flex",
                  width: "40%",
                  justifyContent: "space-around"
                }}
              >
                <p
                  style={{
                    color: "#6C6B6B",
                    fontSize: "16px",
                    fontWeight: "500"
                  }}
                >
                  Clients Count
                </p>
                <p
                  style={{
                    color: primaryColor,
                    fontSize: "16px",
                    fontWeight: "500"
                  }}
                >
                  {roleCounts?.clientCount}
                </p>
              </div>
            )}
          </div>
        )}

        {(role === ADMIN || aclData.includes(TRANSACTION_ACL)) && (
          <>
            <div
              style={{
                borderBottom: "1px solid #F3F3F3",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 20px",
                marginTop: "10px"
              }}
            >
              <p>Recent Transaction</p>
              <CustomButton
                onClick={() => {
                  navigate("/transaction");
                }}
                title="View more"
                styles={{
                  backgroundColor: primaryColor,
                  border: "0px",
                  width: "90px",
                  height: "30px",
                  padding: "0px"
                }}
                textStyles={{ color: "white" }}
              />
            </div>
            <div
              style={{
                padding: "0px 20px",
                overflow: "hidden",
                marginTop: "10px"
              }}
            >
              <CustomTable
                data={transaction?.transactions?.slice(0, 5)}
                headers={TransactionHeaderDashboard}
                totalElements={0}
                totalPages={0}
                styles={{ minHeight: "500px", maxHeight: "500px" }}
              />
            </div>
          </>
        )}
      </div>

      {openAddClientModal && (
        <CustomModal
          headerTitle="Onboard Client"
          open={openAddClientModal}
          onClose={() => {
            setOpenAddClientModal(false);
            dispatch(modalNavigation(1));
            dispatch(removeClientData({}));
          }}
          containerStyle={styles.modalContainerStyle}
          isBackRequired={true}
          onClickBack={() => {
            if (currentModalStep > 1) {
              dispatch(modalNavigation(currentModalStep - 1));
            }
          }}
          isConfirmationModalRequired={true}
        >
          <ClientOnboardIndex
            onSuccess={() => {
              setOpenAddClientModal(false);
              dispatch(modalNavigation(1));
              dispatch(removeClientData({}));
            }}
            onClose={() => {
              setOpenAddClientModal(false);
            }}
          />
        </CustomModal>
      )}

      {reportModal && (
        <CustomModal
          headerTitle="Download Report"
          open={reportModal}
          onClose={() => {
            setReportModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800
          }}
        >
          <DownloadReportModal />
        </CustomModal>
      )}

      {settlementModal && (
        <CustomModal
          headerTitle="Download Settlement Report"
          open={settlementModal}
          onClose={() => {
            setSettlementModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800
          }}
        >
          <DownloadSettlementModal />
        </CustomModal>
      )}
      {openAddResellerModal && (
        <CustomModal
          headerTitle="Onboard Reseller"
          open={openAddResellerModal}
          onClose={() => {
            setOpenAddResellerModal(false);
            dispatch(resellerModalNavigation(1));
            dispatch(removeResellerData({}));
          }}
          containerStyle={styles.modalContainerStyle}
          isBackRequired={currentModalStep?.resellerStep > 1 ? true : false}
          onClickBack={() => {
            if (currentModalStep?.resellerStep > 1) {
              dispatch(
                resellerModalNavigation(currentModalStep?.resellerStep - 1)
              );
            }
          }}
          isConfirmationModalRequired={true}
        >
          <ResellerOnboardIndex
            onSuccess={() => {
              setOpenAddResellerModal(false);
              dispatch(resellerModalNavigation(1));
              dispatch(removeResellerData({}));
            }}
            onClose={() => {
              setOpenAddResellerModal(false);
            }}
          />
        </CustomModal>
      )}

      {onClickDeactivate && (
        <CustomModal
          headerTitle="Deactivate account"
          open={onClickDeactivate}
          onClose={() => {
            setOnClickDeactivate(false);
            dispatch(modalNavigation(1));
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <DeactivateModalIndex
            onSuccess={() => {
              setOnClickDeactivate(false);
            }}
          />
        </CustomModal>
      )}

      {onClickApproval && (
        <CustomModal
          headerTitle="Approval"
          open={onClickApproval}
          onClose={() => {
            setOnCLickedApproval(false);
            dispatch(modalNavigation(1));
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <ApprovalIndex
            onClose={() => {
              setOnCLickedApproval(false);
            }}
            onSuccess={() => {
              setOnCLickedApproval(false);
            }}
          />
        </CustomModal>
      )}

      {onClickSendMoney && (
        <CustomModal
          headerTitle="Send Money"
          open={onClickSendMoney}
          onClose={() => {
            setOnClickSendMoney(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <SendMoneyModal />
        </CustomModal>
      )}
      {onClickAddFunds && (
        <CustomModal
          headerTitle="Add Funds"
          open={onClickAddFunds}
          onClose={() => {
            setOnClickAddFunds(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <AddFundsModal
            onSuccess={() => {
              setOnClickAddFunds(false);
            }}
          />
        </CustomModal>
      )}

      {onClickAddFunds && (
        <CustomModal
          headerTitle="Add Funds"
          open={onClickAddFunds}
          onClose={() => {
            setOnClickAddFunds(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <AddFundsModal
            onSuccess={() => {
              setOnClickAddFunds(false);
            }}
          />
        </CustomModal>
      )}

      {onClickAddPrefund && (
        <CustomModal
          headerTitle="Add Prefund"
          open={onClickAddPrefund}
          onClose={() => {
            setOnClickAddPrefund(false);
          }}
          containerStyle={styles.modalContainerStyle}
          isConfirmationModalRequired={true}
        >
          <AddPrefundModal onSuccess={() => setOnClickAddPrefund(false)} />
        </CustomModal>
      )}
    </div>
  );
}

const styles = {
  iconContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    marginRight: "50px",
    marginLeft: "10px",
    maxWidth: "100px"
  },
  iconContainer1: {
    width: "55px",
    height: "55px",
    border: "1px solid rgba(52, 78, 130, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colorWhite,
    borderRadius: 5
  },
  iconTextStyle: {
    marginTop: 10,
    fontWeight: "500",
    fontSize: 14,
    textAlign: "center",
    color: "#464646"
  },
  iconStyle: {
    height: 28,
    width: 28
  },
  iconMainContainer: {
    width: "100%",
    display: "flex",
    margin: "30px 0px"
  },
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 450,
    height: "auto",
    maxHeight: 800
  }
};
export default DashboardIndex;
